<ion-header class="ion-no-border">
	<ion-toolbar color="white">
		<ion-buttons id="kiosk-nav-ion-buttons" slot="start">
			<ion-button (click)="startOver()" id="kiosk-nav-start-over-btn">
				<fa-icon id="back-icon" [icon]="faChevronLeft" [fixedWidth]="true" size="1x"></fa-icon>
				{{ 'kiosk.startOver' | translate }}
			</ion-button>
			@if(!isProduction){
			<ion-button (click)="exit()" id="kiosk-nav-exit-btn">
				{{ 'kiosk.exitKiosk' | translate }}
			</ion-button>
			}
		</ion-buttons>
		<ion-title>
			<div class="ion-text-wrap"><img class="mt-logo" src="../../../assets/imgs/logo_milktracker.png"/></div>
		</ion-title>
		<ion-text slot="end" id="location-label-text">{{locationText}}</ion-text>
	</ion-toolbar>
</ion-header>
